/// <amd-module name="SuiteCommerce.Blog.ExtCarousel.Slide.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.ExtCarousel.Slide.View", ["require", "exports", "Backbone", "sc_ext_carousel_slide.tpl"], function (require, exports, Backbone_1, extSlideTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ExtCarouselSlideView = void 0;
    var ExtCarouselSlideView = /** @class */ (function (_super) {
        __extends(ExtCarouselSlideView, _super);
        function ExtCarouselSlideView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = extSlideTemplate;
            _this.slideContentView = options.slideContentView;
            return _this;
        }
        Object.defineProperty(ExtCarouselSlideView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'SlideContent.View': function () {
                        return new _this.slideContentView({ model: _this.model });
                    },
                };
            },
            enumerable: false,
            configurable: true
        });
        ExtCarouselSlideView.prototype.getContext = function () {
            return {
                isActive: this.model.isActive,
            };
        };
        return ExtCarouselSlideView;
    }(Backbone_1.View));
    exports.ExtCarouselSlideView = ExtCarouselSlideView;
});
